import BotEditor from "../editor/BotEditor";
const EditorPage = BotEditor;

export default EditorPage;
